import * as React from 'react';
import { MainMenuItem, MenuItemProps, DropMenuProps } from './MainMenu.types';
import { DropMenu } from './DropMenu';
import { getIdFriendlyName } from '../../utils/guid';

/**
 * Represents a single menu link.
 */
export class MenuItem extends React.Component<MenuItemProps> {
  private _groupId: string;
  private _linkId: string;
  private _linkRef: HTMLAnchorElement;

  constructor(props: any) {
    super(props);
    this._groupId = getIdFriendlyName(props.item.Name, 'group');
    this._linkId = getIdFriendlyName(props.item.Name, 'link');
  }

  componentDidMount = () => {
    const { item } = this.props;
    if (item.Url === window.location.pathname) {
      this._linkRef.setAttribute('aria-current', 'page');
    }
  };

  componentDidUpdate = (prevProps: MenuItemProps) => {
    if (prevProps.focusedIndex != this.props.focusedIndex) {
      if (this.props.focusedIndex === this.props.index) {
        this._linkRef.focus();
      }
    }
  };

  isExpanded = () => {
    const { index, focusedIndex, menuHasExpandedDropMenu } = this.props;
    return menuHasExpandedDropMenu && index === focusedIndex;
  };

  renderLink = (item: MainMenuItem, shouldRenderChildren: boolean) => {
    const { focusCb, index } = this.props;
    let activeNode = +item.Selected || item.PathSelected ? ' main-navigation__active' : '';
    let linkClassNames = `main-navigation__link main-navigation__toplink ${activeNode}`;
    if (this.isExpanded()) linkClassNames += ' open';

    let attributes = {
      href: item.Url,
      className: linkClassNames,
    };

    if (shouldRenderChildren) {
      attributes['id'] = this._linkId;
      attributes['aria-controls'] = this._groupId;
      attributes['aria-expanded'] = this.isExpanded();
    }
    return (
      <a {...attributes} ref={(el) => (this._linkRef = el)} onFocus={(_) => focusCb(index)}>
        {item.Name}
      </a>
    );
  };

  render() {
    const { item, index, focusCb } = this.props;
    const shouldRenderChildren = item.HasChildren;
    const dropMenuModel = {
      id: this._groupId,
      labelledBy: this._linkId,
      expanded: this.isExpanded(),
      items: item.Children,
      index,
      focusCb,
    } as DropMenuProps;

    return (
      <li>
        {this.renderLink(item, shouldRenderChildren)}
        {shouldRenderChildren && <DropMenu {...dropMenuModel} />}
      </li>
    );
  }
}
